export type OS = 'ios' | 'android' | 'windows' | 'mac' | 'linux';
export type OpenResult = 'opened' | 'not-installed';

export interface AppDownloads {
  android?: string;
  windows?: string;
  mac?: string;
  linux?: string;
}

export function detectOS(): OS {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua) && !(window as any).MSStream) return 'ios';
  if (/Android/.test(ua)) return 'android';
  if (/Windows NT/.test(ua)) return 'windows';
  if (/Macintosh|Mac OS X/.test(ua)) return 'mac';
  return 'linux';
}

export function getDevice(): 'ios' | 'android' | 'desktop' {
  const os = detectOS();
  if (os === 'ios') return 'ios';
  if (os === 'android') return 'android';
  return 'desktop';
}

export function isStandalone(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as any).standalone === true
  );
}

export function markPwaInstalled(cookieName: string) {
  document.cookie = `${cookieName}=1; max-age=31536000; path=/; SameSite=Lax`;
}

export function isPwaInstalledIos(cookieName: string): boolean {
  return document.cookie.includes(`${cookieName}=1`);
}

export function getDownloadUrl(downloads: AppDownloads, os: OS): string | null {
  switch (os) {
    case 'android': return downloads.android ?? null;
    case 'windows': return downloads.windows ?? null;
    case 'mac':     return downloads.mac ?? null;
    case 'linux':   return downloads.linux ?? null;
    default:        return null;
  }
}

export function getOSLabel(os: OS): string {
  const labels: Record<OS, string> = {
    windows: 'Windows',
    mac:     'macOS',
    linux:   'Linux',
    android: 'Android',
    ios:     'iOS',
  };
  return labels[os];
}

export function tryOpenApp(scheme: string): Promise<OpenResult> {
  return new Promise((resolve) => {
    let done = false;
    const finish = (result: OpenResult) => {
      if (done) return;
      done = true;
      window.removeEventListener('blur', onBlur);
      clearTimeout(timer);
      resolve(result);
    };
    const onBlur = () => finish('opened');
    window.addEventListener('blur', onBlur);
    const timer = setTimeout(() => finish('not-installed'), 2000);
    window.location.href = `${scheme}://open`;
  });
}
